<div class="account-settings-card" [class.rtl-enabled]="themeService.isRTLEnabled()">
  <mat-stepper linear>
    <!-- Step 1: User Profile -->
    <mat-step [stepControl]="userForm">
      <ng-template matStepLabel>I. Korisnički podaci</ng-template>
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title><h5 class="mb-0">I. Korisnički podaci</h5></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <form [formGroup]="userForm">
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Ime</mat-label>
                <input matInput formControlName="firstName" placeholder="Ime">
              </mat-form-field>
            </div>
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Prezime</mat-label>
                <input matInput formControlName="lastName" placeholder="Prezime">
              </mat-form-field>
            </div>
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" placeholder="Email korisnika">
              </mat-form-field>
            </div>
            <button mat-flat-button matStepperNext class="daxa" [disabled]="userForm.invalid">Dalje</button>
          </form>
        </mat-card-content>
      </mat-card>
    </mat-step>

    <!-- Show association steps only if user is association user -->
    @if (isAssociationUser) {
      <!-- Step 2: Osnovni podaci o udruzi -->
      <mat-step [stepControl]="associationBasicInfoForm">
        <ng-template matStepLabel>II. Osnovni podaci o udruzi</ng-template>
        <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
          <mat-card-header>
            <mat-card-title><h5 class="mb-0">II. Osnovni podaci o udruzi</h5></mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <form [formGroup]="associationBasicInfoForm">
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Naziv udruge</mat-label>
                  <input matInput formControlName="name" placeholder="Naziv udruge" />
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>OIB</mat-label>
                  <input matInput formControlName="oib" placeholder="OIB" />
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>RNO</mat-label>
                  <input matInput formControlName="rno" placeholder="RNO" />
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Email udruge</mat-label>
                  <input matInput formControlName="email" placeholder="Email udruge" />
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Godina osnutka</mat-label>
                  <input matInput formControlName="yearOfEstablishment" type="number" placeholder="Godina osnutka" />
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Datum upisa u matični registar</mat-label>
                  <input matInput [matDatepicker]="picker" formControlName="dateOfRegistration" placeholder="Datum registracije" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Registarski broj</mat-label>
                  <input matInput formControlName="registrationNumber" placeholder="Registarski broj" />
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Registrirana pri</mat-label>
                  <input matInput formControlName="registeredAuthority" placeholder="Naziv registracijskog tijela" />
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Naziv banke</mat-label>
                  <input matInput formControlName="bankName" placeholder="Naziv banke" />
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Broj žiro-računa (IBAN)</mat-label>
                  <input matInput formControlName="bankAccountNumber" placeholder="Broj žiro-računa" />
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Kontakt broj</mat-label>
                  <input matInput formControlName="contactNumber" placeholder="Kontakt broj" />
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Web</mat-label>
                  <input matInput formControlName="web" placeholder="Web stranica" />
                </mat-form-field>
              </div>
              <div>
                <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
                <button mat-flat-button matStepperNext class="daxa" [disabled]="associationBasicInfoForm.invalid">Dalje</button>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
      </mat-step>
      <!-- Step 3: Podaci o sjedištu -->
      <mat-step [stepControl]="associationHeadquartersForm">
        <ng-template matStepLabel>III. Podaci o sjedištu</ng-template>
        <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
          <mat-card-header>
            <mat-card-title><h5 class="mb-0">III. Podaci o sjedištu</h5></mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <form [formGroup]="associationHeadquartersForm">
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Županija</mat-label>
                  <input matInput formControlName="county" placeholder="Županija" />
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Poštanski broj i sjedište</mat-label>
                  <input matInput formControlName="postalCodeAndHeadquarters" placeholder="Poštanski broj i sjedište" />
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Adresa</mat-label>
                  <input matInput formControlName="address" placeholder="Adresa (ulica i broj)" />
                </mat-form-field>
              </div>
              <div>
                <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
                <button mat-flat-button matStepperNext class="daxa" [disabled]="associationHeadquartersForm.invalid">Dalje</button>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
      </mat-step>
      <!-- Step 4: Dodatni podaci -->
      <mat-step [stepControl]="associationDetailsForm">
        <ng-template matStepLabel>IV. Dodatni podaci</ng-template>
        <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
          <mat-card-header>
            <mat-card-title><h5 class="mb-0">IV. Dodatni podaci</h5></mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <form [formGroup]="associationDetailsForm">
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Ciljevi osnivanja sukladno Statutu</mat-label>
                  <textarea matInput formControlName="objectivesAccordingToStatute" placeholder="Ciljevi"></textarea>
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Svrha i područje djelovanja</mat-label>
                  <textarea matInput formControlName="purposeAndFieldOfOperation" placeholder="Svrha i područje djelovanja"></textarea>
                </mat-form-field>
              </div>
              <div class="mb-25">
                <mat-form-field class="full-width">
                  <mat-label>Djelatnosti prema Statutu</mat-label>
                  <textarea matInput formControlName="activitiesAccordingToStatute" placeholder="Djelatnosti"></textarea>
                </mat-form-field>
              </div>
              <div>
                <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
                <button mat-flat-button color="primary" (click)="saveProfile()" [disabled]="associationDetailsForm.invalid">Spremi</button>
              </div>
            </form>
          </mat-card-content>
        </mat-card>
      </mat-step>
    }

    <!-- If not association user, final step is just confirmation/save -->
    @if (!isAssociationUser) {
      <mat-step>
        <ng-template matStepLabel>Potvrda</ng-template>
        <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
          <mat-card-header>
            <mat-card-title><h5 class="mb-0">Potvrda</h5></mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div>
              <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
              <button mat-flat-button color="primary" (click)="saveProfile()">Spremi</button>
            </div>
          </mat-card-content>
        </mat-card>
      </mat-step>
    }

  </mat-stepper>
</div>